class GATracking {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState !== "loading") {
      this.bindEvents();
      this.trackPageView();
    } else {
      document.addEventListener("DOMContentLoaded", () => {
        this.bindEvents();
        this.trackPageView();
      });
    }

    // document.addEventListener("page:loaded", () => {
    //   this.trackPageView();
    // });
  }

  observeElementOnce(options) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: options.threshold || 0,
      }
    );

    observer.observe(options.element);

    return observer;
  }

  observeElement(options) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
            }
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: options.threshold || 0,
      }
    );

    observer.observe(options.element);

    return observer;
  }

  sendEvent(eventData) {
    eventData.timestamp = Date.now();

    if (typeof gtag === "function") {
      console.log("GA Tracking: ", eventData);

      // if (Shopify?.theme?.role == "unpublished") {
      //   return;
      // }
      // requestAnimationFrame(() => {
      // setTimeout(() => {
      gtag("event", eventData.event_name, {
        ...eventData,
      });
      // }, 0);
      // });
    } else {
      console.warn("GA Tracking: gtag函数未定义，仅在控制台输出事件");
    }
  }

  trackPageView() {
    const pageType = window.location.pathname;

    this.sendEvent({
      event_name: "page_view",
      event_type: "view",
      page: pageType,
      element: "page",
      action_value: "view",
    });

    this.pageLoadTime = new Date();

    window.addEventListener("beforeunload", () => {
      const timeSpent = (new Date() - this.pageLoadTime) / 1000;

      this.sendEvent({
        event_name: "page_time_spent",
        event_type: "view",
        page: pageType,
        element: "page",
        action_value: timeSpent.toFixed(0),
      });
    });
  }

  bindEvents() {
    try {
      this.bindGlobalEvents();
      this.bindHomeEvents();
      this.bindProductEvents();
      this.bindCartEvents();
      this.bindScrollEvents();
      this.bindClickEvents();
      this.bindOtherPageEvents();
    } catch (error) {
      console.error("Events Errors", error);
    }
  }

  bindGlobalEvents() {
    const pageType = window.location.pathname;

    document.addEventListener("click", (e) => {
      // 菜单点击
      const navItem = e.target.closest(
        ".header__inline-menu a, .menu-drawer a, li .menu-drawer__menu-item"
      );
      if (navItem) {
        this.sendEvent({
          event_name: "click_top_nav_item",
          event_type: "click",
          page: pageType,
          element: "top_nav_item",
          action_value: navItem.textContent.trim(),
        });
      }

      // 产品点击
      const prdItem = e.target.closest(
        ".shelves-menu-product-list .shelves-menu-product-list__item"
      );
      if (prdItem) {
        this.sendEvent({
          event_name: "click_shelves_menu_item",
          event_type: "click",
          page: pageType,
          element: "shelves-menu-product",
          action_value: prdItem
            .querySelector("a.card-information__text")
            ?.textContent.trim(),
        });
      }

      const searchToggle = e.target.closest(
        "search-modal .modal__toggle-open, .header__icon--search"
      );
      if (searchToggle) {
        this.sendEvent({
          event_name: "click_search_toggle",
          event_type: "click",
          page: pageType,
          element: "search_toggle",
          action_value: "open",
        });
      }

      const menuToggle = e.target.closest(".header__icon--menu");
      if (menuToggle) {
        this.sendEvent({
          event_name: "click_menu_toggle",
          event_type: "click",
          page: pageType,
          element: "menu_toggle",
          action_value: "open",
        });
      }

      const headingLink = e.target.closest(".header__heading-link");
      if (headingLink) {
        this.sendEvent({
          event_name: "click_heading_link",
          event_type: "click",
          page: pageType,
          element: "heading_link",
          action_value: "click",
        });
      }
    });

    const sidebarCollections = document.querySelectorAll(
      ".menu-drawer__inner-container  .li-shelves_menu"
    );
    sidebarCollections.forEach((sidebarCollection) => {
      const title =
        sidebarCollection
          .querySelector(".menu-drawer__menu-item")
          ?.textContent.trim() || "unknown_collection";

      this.observeElementOnce({
        element: sidebarCollection,
        callback: () => {
          this.sendEvent({
            event_name: "view_sidebar_menu_collection",
            event_type: "view",
            page: pageType,
            element: `collection_${title}`,
            action_value: "view",
          });
        },
        threshold: 0.8,
      });

      let touchStartX;
      sidebarCollection.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      sidebarCollection.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "scroll_sidebar_menu_collection",
            event_type: "scroll",
            page: pageType,
            element: `menu_${title}`,
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    });

    document.addEventListener("click", (e) => {
      const footerItem = e.target.closest(".footer-block a");
      if (footerItem) {
        this.sendEvent({
          event_name: "click_footer_menu_item",
          event_type: "click",
          page: pageType,
          element: "footer_menu_item",
          action_value: footerItem.textContent.trim(),
        });
      }
    });
  }

  bindHomeEvents() {
    const pageType = window.location.pathname;

    if (pageType !== "/" && pageType !== "/index") {
      return;
    }

    this.trackBannerEvents();
    this.trackCollectionEvents();
    this.trackConcernCardEvents();
    this.trackCompareReviewsEvents();
    this.trackVideoEvents();
    this.trackHomeCollageEvents();
    this.trackEffectSliderEvents();
  }

  trackBannerEvents() {
    const pageType = window.location.pathname;

    document.addEventListener("click", (e) => {
      const banner = e.target.closest(".slideshow__slide, .banner");
      if (banner) {
        const bannerId =
          banner.id ||
          banner.dataset.id ||
          banner.dataset.index ||
          "unknown_banner";
        this.sendEvent({
          event_name: "click_banner",
          event_type: "click",
          page: pageType,
          element: `banner_${bannerId}`,
          action_value: "click",
        });
      }
    });

    const bannerSlider = document.querySelector(".slideshow");
    if (bannerSlider) {
      let isMouseDown = false;
      let startX;
      let scrollLeft;

      bannerSlider.addEventListener("mousedown", (e) => {
        isMouseDown = true;
        startX = e.pageX - bannerSlider.offsetLeft;
        scrollLeft = bannerSlider.scrollLeft;
      });

      bannerSlider.addEventListener("mouseleave", () => {
        isMouseDown = false;
      });

      bannerSlider.addEventListener("mouseup", (e) => {
        if (!isMouseDown) return;
        isMouseDown = false;

        const x = e.pageX - bannerSlider.offsetLeft;
        const walk = x - startX;

        if (Math.abs(walk) > 50) {
          const direction = walk > 0 ? "right" : "left";
          this.sendEvent({
            event_name: "scroll_banner",
            event_type: "scroll",
            page: pageType,
            element: "banner_slider",
            action_value: direction,
          });
        }
      });

      let touchStartX;
      bannerSlider.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      bannerSlider.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";
          this.sendEvent({
            event_name: "scroll_banner",
            event_type: "scroll",
            page: pageType,
            element: "banner_slider",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    }

    const banners = document.querySelectorAll(".slideshow__slide, .banner");
    banners.forEach((banner, index) => {
      const bannerId =
        banner.id ||
        banner.dataset.id ||
        banner.dataset.index ||
        "unknown_banner";
      this.observeElementOnce({
        element: banner,
        callback: () => {
          this.sendEvent({
            event_name: "view_banner",
            event_type: "view",
            page: pageType,
            element: `banner_${bannerId}`,
            action_value: "view",
          });
        },
        threshold: 0.6,
      });
    });
  }

  trackConcernCardEvents() {
    const pageType = window.location.pathname;

    const collections = document.querySelectorAll(".featured-shop-by-concern");
    collections.forEach((collection) => {
      this.observeElementOnce({
        element: collection,
        callback: () => {
          const collectionTitle =
            collection.querySelector(".title")?.textContent.trim() ||
            "unknown_title";

          this.sendEvent({
            event_name: "view_concern",
            event_type: "view",
            page: pageType,
            element: `concern_${collectionTitle}`,
            action_value: collectionTitle,
          });
        },
        threshold: 0.8,
      });
    });

    document.addEventListener("click", (e) => {
      const productItem = e.target.closest(
        ".featured-shop-by-concern .concern-card-link"
      );
      if (productItem) {
        const productTitle =
          productItem
            .querySelector("a.concern-card-link-content")
            ?.textContent.trim() || "unknown_concern";

        this.sendEvent({
          event_name: "click_concern_item",
          event_type: "click",
          page: pageType,
          element: `item_${productTitle}`,
          action_value: "click",
        });
      }
    });
  }

  trackCollectionEvents() {
    const pageType = window.location.pathname;

    const collections = document.querySelectorAll(".featured-collection");
    collections.forEach((collection) => {
      this.observeElementOnce({
        element: collection,
        callback: () => {
          const collectionTitle =
            collection.dataset.collectionTitle ||
            collection.querySelector(".title")?.textContent.trim() ||
            "unknown_title";

          this.sendEvent({
            event_name: "view_collection",
            event_type: "view",
            page: pageType,
            element: `collection_${collectionTitle}`,
            action_value: collectionTitle,
          });
        },
        threshold: 0.8,
      });
    });

    document.addEventListener("click", (e) => {
      const productItem = e.target.closest(
        ".featured-collection .grid-item, .featured-collection  .card-wrapper"
      );
      if (productItem) {
        const productTitle =
          productItem
            .querySelector(".card-information a")
            ?.textContent.trim() || "unknown_product";

        this.sendEvent({
          event_name: "click_collection_product",
          event_type: "click",
          page: pageType,
          element: `collection_product_${productTitle}`,
          action_value: "click",
        });
      }
    });

    const collectionSliders = document.querySelectorAll(".featured-collection");
    collectionSliders.forEach((collection) => {
      const slider = collection.querySelector(".slider");
      if (!slider.classList.contains("thumbnail-list")) {
        let isMouseDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener("mousedown", (e) => {
          isMouseDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener("mouseleave", () => {
          isMouseDown = false;
        });

        slider.addEventListener("mouseup", (e) => {
          if (!isMouseDown) return;
          isMouseDown = false;

          const x = e.pageX - slider.offsetLeft;
          const walk = x - startX;

          if (Math.abs(walk) > 50) {
            const direction = walk > 0 ? "right" : "left";
            const collectionId =
              slider.closest("[data-collection-id]")?.dataset.collectionId ||
              "unknown_collection";

            this.sendEvent({
              event_name: "scroll_collection",
              event_type: "scroll",
              page: pageType,
              element: `collection_slider_${collectionId}`,
              action_value: direction,
              collection_id: collectionId,
            });
          }
        });

        let touchStartX;
        slider.addEventListener(
          "touchstart",
          (e) => {
            touchStartX = e.touches[0].pageX;
          },
          { passive: true }
        );

        slider.addEventListener("touchend", (e) => {
          if (!touchStartX) return;
          const touchEndX = e.changedTouches[0].pageX;
          const diff = touchStartX - touchEndX;

          if (Math.abs(diff) > 50) {
            const direction = diff > 0 ? "left" : "right";
            const collectionTitle =
              collection.dataset.collectionTitle ||
              collection.querySelector(".title")?.textContent.trim() ||
              "unknown_title";

            this.sendEvent({
              event_name: "scroll_collection",
              event_type: "scroll",
              page: pageType,
              element: `collection_${collectionTitle}`,
              action_value: collectionTitle,
            });
          }
          touchStartX = null;
        });
      }
    });
  }

  trackVideoEvents() {
    const pageType = window.location.pathname;

    const videoSections = document.querySelectorAll(".expert-video-section");
    if (videoSections.length == 0) {
      return;
    }
    videoSections.forEach((videos) => {
      this.observeElementOnce({
        element: videos,
        callback: () => {
          const videosTitle =
            videos.querySelector(".expert-video-title")?.textContent.trim() ||
            "unknown_video";

          this.sendEvent({
            event_name: "view_video",
            event_type: "view",
            page: pageType,
            element: `video_${videosTitle}`,
            action_value: "view",
          });
        },
        threshold: 0,
      });
    });

    document.addEventListener("click", (e) => {
      const video = e.target.closest(
        ".expert-video-section  .expert-video-item-content"
      );
      if (video) {
        const videoId = video.dataset.title || "unknown_video";

        this.sendEvent({
          event_name: "click_video",
          event_type: "click",
          page: pageType,
          element: `video_${videoId}`,
          action_value: "click",
        });
      }

      const product = e.target.closest(
        ".expert-video-section .expert-video-list-item-product"
      );
      if (product) {
        const productTitle =
          product
            .querySelector(
              ".expert-video-list-item-product .product-info__title"
            )
            ?.textContent.trim() || "unknown_product";

        this.sendEvent({
          event_name: "click_video_product",
          event_type: "click",
          page: pageType,
          element: `video_product_${productTitle}`,
          action_value: "click",
        });
      }
    });

    document.addEventListener("click", (e) => {
      const videoNav = e.target.closest(".expert-video-arrow-button-container");
      if (videoNav) {
        const videoParent = videoNav.closest(".expert-video-section");
        const videoId = videoParent?.dataset.title || "unknown_video";
        const direction =
          videoParent?.querySelector(".expert-video-arrow-button-container") ==
          videoNav
            ? "prev"
            : "next";

        this.sendEvent({
          event_name: "click_video_nav",
          event_type: "click",
          page: pageType,
          element: `video_nav_${direction}`,
          action_value: direction,
        });
      }
    });

    const videoSliders = document.querySelectorAll(
      ".expert-section-video-content"
    );
    videoSliders.forEach((slider) => {
      let touchStartX;
      slider.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      slider.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "swipe_video",
            event_type: "swipe",
            page: pageType,
            element: "video_slider",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    });
  }

  trackCompareReviewsEvents() {
    const pageType = window.location.pathname;

    const videoSections = document.querySelectorAll(
      ".skin-transformation-reviews"
    );
    if (videoSections.length == 0) {
      return;
    }
    videoSections.forEach((videos) => {
      this.observeElementOnce({
        element: videos,
        callback: () => {
          const videosTitle =
            videos.querySelector(".title-wrapper .title")?.textContent.trim() ||
            "unknown_reviews";

          this.sendEvent({
            event_name: "view_compare_reviews",
            event_type: "view",
            page: pageType,
            element: `compare_reviews_${videosTitle}`,
            action_value: "view",
          });
        },
        threshold: 0,
      });
    });

    document.addEventListener("click", (e) => {
      const product = e.target.closest(
        ".skin-transformation-reviews .str-product-item"
      );
      if (product) {
        const productTitle =
          product
            .querySelector(".str-product-info__title")
            ?.textContent.trim() || "unknown_product";

        this.sendEvent({
          event_name: "click_reviews_product",
          event_type: "click",
          page: pageType,
          element: `reviews_product_${productTitle}`,
          action_value: "click",
        });
      }
    });

    const videoSliders = document.querySelectorAll(
      ".skin-transformation-reviews .str-content-swiper"
    );
    videoSliders.forEach((slider) => {
      let touchStartX;
      slider.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      slider.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "swipe_compare_reviews",
            event_type: "swipe",
            page: pageType,
            element: "compare_reviews_slider",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    });
  }

  trackHomeCollageEvents() {
    const pageType = window.location.pathname;

    const faqItems = document.querySelectorAll("#section-faq");
    faqItems.forEach((faq, index) => {
      this.observeElementOnce({
        element: faq,
        callback: () => {
          const faqId =
            faq.querySelector(".title-wrapper .title")?.textContent.trim() ||
            `collapsible_${index + 1}`;

          this.sendEvent({
            event_name: "view_collapsible_content",
            event_type: "view",
            page: pageType,
            element: `collapsible_${faqId}`,
            action_value: "view",
          });
        },
        threshold: 0.3,
      });
    });
  }

  trackEffectSliderEvents() {
    const pageType = window.location.pathname;

    const effectSliders = document.querySelectorAll(
      ".media-evaluation-section"
    );
    effectSliders.forEach((slider) => {
      const title =
        slider.querySelector(".title")?.textContent.trim() || "unknown_effect";

      let touchStartX;
      slider.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      slider.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "swipe_effect_slider",
            event_type: "swipe",
            page: pageType,
            element: "effect_slider" + title,
            action_value: direction,
          });
        }
        touchStartX = null;
      });

      slider.addEventListener("click", (e) => {
        const videoNav = e.target.closest(".media-real-arrow");
        if (videoNav) {
          const videoParent = videoNav.closest(".media-evaluation-section");

          const direction =
            videoParent?.querySelector(".media-real-bottom-arrow-item") ==
            e.target
              ? "prev"
              : "next";
          this.sendEvent({
            event_name: "swipe_effect_slider",
            event_type: "swipe",
            page: pageType,
            element: "effect_slider" + title,
            action_value: direction,
          });
        }
      });
    });

    document.addEventListener("click", (e) => {
      const effectItem = e.target.closest("accordion-tab");
      if (effectItem) {
        const effectId =
          effectItem.querySelector(".accordion__title")?.textContent.trim() ||
          "unknown_effect";

        this.sendEvent({
          event_name: "click_effect_data_item",
          event_type: "click",
          page: pageType,
          element: `effect_item_data_${effectId}`,
          action_value: effectId,
        });
      }

      const blog = e.target.closest(
        ".blog-info-item, .blog-info-left, .blog-item"
      );
      if (blog) {
        const blogTitle =
          blog
            .querySelector(
              ".blog-info-item-title, .blog-info-left-title, .blog-item--title"
            )
            ?.textContent.trim() || "unknown_blog";

        this.sendEvent({
          event_name: "click_insight_item",
          event_type: "click",
          page: pageType,
          element: `insight_${blogTitle}`,
          action_value: blogTitle,
        });
      }
    });

    const blogSections = document.querySelectorAll("section .blog");
    blogSections.forEach((blog) => {
      this.observeElementOnce({
        element: blog,
        callback: () => {
          const videosTitle =
            blog.querySelector(".title-wrapper  .title")?.textContent.trim() ||
            "unknown_video";

          this.sendEvent({
            event_name: "view_blog",
            event_type: "view",
            page: pageType,
            element: `blog_${videosTitle}`,
            action_value: "view",
          });
        },
        threshold: 0,
      });
    });

    document
      .querySelector("a[href='/pages/about-theinia']")
      ?.addEventListener("click", (e) => {
        this.sendEvent({
          event_name: "click_philosophy_more",
          event_type: "click",
          page: pageType,
          element: "our_philosophy-read_more",
          action_value: "click",
        });
      });
  }

  bindProductEvents() {
    const pageType = window.location.pathname;

    if (!pageType.startsWith("/products/")) {
      return;
    }

    const mediaGallery = document.querySelector("product-gallery .slider");
    if (mediaGallery) {
      let touchStartX;
      mediaGallery.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      mediaGallery.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "scroll_product_images",
            event_type: "scroll",
            page: pageType,
            element: "product_image_slider",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    }

    document.addEventListener("click", (e) => {
      const thumbnail = e.target.closest(".thumbnail-list__item");
      if (thumbnail) {
        const mediaId = thumbnail.dataset.mediaPosition || "unknown_media";

        this.sendEvent({
          event_name: "click_main_image_nav",
          event_type: "click",
          page: pageType,
          element: `thumbnail_${mediaId}`,
          action_value: "click",
        });
      }
    });

    document.addEventListener("click", (e) => {
      const main_image_nav_prev = e.target.closest(
        ".product__media-gallery .thumbnail-slider .slider-buttons .slider-button--prev"
      );
      if (main_image_nav_prev) {
        this.sendEvent({
          event_name: "click_main_image_nav_btn",
          event_type: "click",
          page: pageType,
          element: `main_image_nav_btn_prev`,
          action_value: "click",
        });
      }

      const main_image_nav_next = e.target.closest(
        ".product__media-gallery .thumbnail-slider .slider-buttons .slider-button--next"
      );
      if (main_image_nav_next) {
        this.sendEvent({
          event_name: "click_main_image_nav_btn",
          event_type: "click",
          page: pageType,
          element: `main_image_nav_btn_next`,
          action_value: "click",
        });
      }
    });

    const thumbnailList = document.querySelector(
      "thumbnail-slider .thumbnail-list"
    );
    if (thumbnailList) {
      let touchStartX;
      thumbnailList.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      thumbnailList.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "scroll_main_image_nav",
            event_type: "scroll",
            page: pageType,
            element: "scroll_main_image_nav",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    }

    document.addEventListener("click", (e) => {
      const skuOption = e.target.closest(".select-option");
      if (skuOption) {
        const skuId = skuOption.dataset.value || "unknown_sku";

        this.sendEvent({
          event_name: "click_sku_item",
          event_type: "click",
          page: pageType,
          element: `sku_${skuId}`,
          action_value: "click",
          sku_id: skuId,
        });
      }

      const videoOption = e.target.closest(".tolstoy-tile");
      if (videoOption) {
        const title = videoOption.dataset.title || "unknown_sku_video";
        this.sendEvent({
          event_name: "click_sku_video_item",
          event_type: "click",
          page: pageType,
          element: `sku_video_${title}`,
          action_value: "click",
          video_title: title,
        });
      }

      const couponClick = e.target.closest(".profy-inpage-banner");
      if (couponClick) {
        this.sendEvent({
          event_name: "click_coupon_copy",
          event_type: "click",
          page: pageType,
          element: `coupon_${e.target.textContent.trim()}`,
          action_value: "click",
        });
      }
    });

    document.addEventListener("click", (e) => {
      const addToCart = e.target.closest(".product-form--add-to-cart");
      if (addToCart) {
        this.sendEvent({
          event_name: "click_add_to_cart",
          event_type: "click",
          page: pageType,
          element: "add_to_cart_btn",
          action_value: "click",
        });
      }
    });

    document.addEventListener("click", (e) => {
      const addToCart = e.target.closest('[id="buyNow"]');
      if (addToCart) {
        this.sendEvent({
          event_name: "click_buyNow",
          event_type: "click",
          page: pageType,
          element: "buyNow_btn",
          action_value: "click",
        });
      }
    });

    const tolstoyList = document.querySelector(".tolstoy-container");
    if (tolstoyList) {
      let touchStartX;
      tolstoyList.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      tolstoyList.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "scroll_sku_video",
            event_type: "scroll",
            page: pageType,
            element: "scroll_sku_video",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    }

    const handleBoughtTogetherAppFunc = () => {
      const boughtTogetherApps = document.querySelectorAll(
        "essential-upsell-frequently-bought-together-app-block"
      );

      boughtTogetherApps.forEach((boughtTogetherApp) => {
        this.observeElementOnce({
          element: boughtTogetherApp,
          callback: () => {
            this.sendEvent({
              event_name: "view_boughtTogether",
              event_type: "view",
              page: pageType,
              element: `bought-together-app`,
              action_value: "view",
            });
          },
          threshold: 0.6,
        });

        boughtTogetherApp
          .querySelectorAll(
            "button[data-essential-upsell-element='add-to-cart-button']"
          )
          .forEach((button) => {
            button.addEventListener("click", () => {
              this.sendEvent({
                event_name: "click_boughtTogether_btn",
                event_type: "click",
                page: pageType,
                element: `bought-together-app_btn`,
                action_value: "click",
              });
            });
          });
      });
    };

    const boughtTogetherAppTtn = document.querySelector(
      "button[data-essential-upsell-element='add-to-cart-button']"
    );
    if (boughtTogetherAppTtn) {
      handleBoughtTogetherAppFunc();
    } else {
      const boughtTogetherBlock = document.querySelector(
        '[id*="essential_upsell_frequently_bought_together_app"]'
      );
      if (boughtTogetherBlock) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              mutation.addedNodes.length > 0 &&
              boughtTogetherBlock.querySelector(
                "button[data-essential-upsell-element='add-to-cart-button']"
              ) &&
              Array.from(mutation.addedNodes).some(
                (node) => node.nodeType === 1 && node.matches("button")
              )
            ) {
              handleBoughtTogetherAppFunc();
              observer.disconnect();
            }
          });
        });
        observer.observe(boughtTogetherBlock, {
          childList: true,
          subtree: true,
        });
      }
    }

    const faqItems = document.querySelectorAll("#section-faq");
    faqItems.forEach((faq, index) => {
      this.observeElementOnce({
        element: faq,
        callback: () => {
          const faqId =
            faq.querySelector(".title-wrapper .title")?.textContent.trim() ||
            `faqs_${index + 1}`;

          this.sendEvent({
            event_name: "view_faq_block",
            event_type: "view",
            page: pageType,
            element: `faq_${faqId}`,
            action_value: "view",
          });
        },
        threshold: 0.3,
      });
    });

    document.addEventListener("click", (e) => {
      const faqHeader = e.target.closest("#section-faq .accordion summary");
      if (faqHeader) {
        const faq = faqHeader.closest(".accordion");
        const faqId =
          faq?.querySelector(".summary__title")?.textContent.trim() ||
          "unknown_faq";

        this.sendEvent({
          event_name: "click_faq_item",
          event_type: "click",
          page: pageType,
          element: `faq_${faqId}`,
          action_value: "click",
          faq_title: faqId,
        });
      }
    });

    document.addEventListener("click", (e) => {
      const looxReviewsRate = e.target.closest("a[href^='#looxReviews']");
      if (looxReviewsRate) {
        this.sendEvent({
          event_name: looxReviewsRate.classList.contains("see-all-reviews")
            ? "click_comment_star_text"
            : "click_comment_star",
          event_type: "click",
          page: pageType,
          element: `loox-rating`,
          action_value: "click",
        });
      }
    });

    document.addEventListener("click", (e) => {
      const tabnav = e.target.closest(".sticky-navigation a");
      if (tabnav) {
        this.sendEvent({
          event_name: "click_tab_nav",
          event_type: "click",
          page: pageType,
          element: `sticky-navigation`,
          action_value: tabnav.textContent.trim(),
        });
      }
    });

    let resizeCount = 0;
    window.addEventListener("message", (event) => {
      if (event.origin !== "https://loox.io" && !event.data) {
        return;
      }

      let data = event.data;
      if (
        typeof event.data == "string" &&
        event.data.startsWith("{") &&
        event.data.endsWith("}")
      ) {
        data = JSON.parse(event.data);
      } else {
        return;
      }
      if (
        data &&
        data.type == "set-ref-interaction" &&
        data.ref == "loox-header-dist"
      ) {
        this.sendEvent({
          event_name: "click_comment_tab",
          event_type: "click",
          page: pageType,
          element: "comment_tab",
          action_value: "click",
        });
      }

      if (data && data.type == "resize" && data.frame == "looxReviewsFrame") {
        resizeCount++;
        if (resizeCount == 1) return;
        this.sendEvent({
          event_name: "click_more_comments",
          event_type: "click",
          page: pageType,
          element: "more_comments_btn",
          action_value: "click",
        });
      }
      if (data && data.type == "quickview") {
        const commentId = data.postId || "unknown_comment";

        this.sendEvent({
          event_name: "click_comment",
          event_type: "click",
          page: pageType,
          element: `comment_loox_${commentId}`,
          action_value: "click",
          comment_id: commentId,
        });
      }
    });
  }

  bindCartEvents() {
    const pageType = window.location.pathname;

    const cartDrawer = document.querySelector("mini-cart");
    if (cartDrawer) {
      this.observeElement({
        element: cartDrawer,
        callback: () => {
          this.sendEvent({
            event_name: "view_cart_drawer",
            event_type: "view",
            page: pageType,
            element: "cart_drawer",
            action_value: "view",
          });
        },
        threshold: 0.5,
      });

      cartDrawer.addEventListener("click", (e) => {
        const addToCartBtn = e.target.closest(
          ".cart-recommendations_item add-to-cart"
        );
        if (addToCartBtn) {
          const product = addToCartBtn.closest(".cart-recommendations_item");
          const productName =
            product
              ?.querySelector(".product-description .product-content a")
              ?.textContent.trim() || "unknown_product";
          const productId =
            addToCartBtn?.dataset.variantId || "unknown_product";

          this.sendEvent({
            event_name: "click_add_recommendation",
            event_type: "click",
            page: pageType,
            element: `cart_recommendation_add-to-cart`,
            action_value: "click",
            product_id: productId,
            product_name: productName,
          });
        }
      });

      cartDrawer.addEventListener("click", (e) => {
        const checkoutBtn = e.target.closest("button[name='checkout']");
        if (checkoutBtn) {
          this.sendEvent({
            event_name: "click_secure_checkout",
            event_type: "click",
            page: pageType,
            element: "secure_checkout_btn",
            action_value: "click",
          });
        }
      });
    }
  }

  bindScrollEvents() {
    const pageType = window.location.pathname;

    const footer = document.querySelector("footer");
    if (footer) {
      this.observeElementOnce({
        element: footer,
        callback: () => {
          this.sendEvent({
            event_name: "scroll_to_bottom",
            event_type: "scroll",
            page: pageType,
            element: "page",
            action_value: "bottom",
          });
        },
        threshold: 0.4,
      });
    }
  }

  bindClickEvents() {
    const pageType = window.location.pathname;

    document.addEventListener("click", (e) => {
      const sidebarItem = e.target.closest(".sidebar-menu a");
      if (sidebarItem) {
        const itemType = sidebarItem.closest(".collection-sidebar")
          ? "product"
          : "menu";
        const itemId =
          sidebarItem.dataset.productId || sidebarItem.textContent.trim();

        this.sendEvent({
          event_name: "click_sidebar_menu_item",
          event_type: "click",
          page: pageType,
          element: `sidebar_${itemType}_${itemId}`,
          action_value: "click",
          item_type: itemType,
          item_id: itemId,
        });
      }
    });
  }

  bindOtherPageEvents() {
    const pageType = window.location.pathname;

    const videoSections = document.querySelectorAll(
      ".skin-transformation-comments"
    );
    videoSections.forEach((videos) => {
      this.observeElementOnce({
        element: videos,
        callback: () => {
          const videosTitle =
            videos.querySelector(".title-wrapper .title")?.textContent.trim() ||
            "unknown_reviews";

          this.sendEvent({
            event_name: "view_compare_comments",
            event_type: "view",
            page: pageType,
            element: `compare_comments_${videosTitle}`,
            action_value: "view",
          });
        },
        threshold: 0,
      });
    });

    document.addEventListener("click", (e) => {
      const product = e.target.closest(
        ".skin-transformation-comments .strc-product-item"
      );
      if (product) {
        const productTitle =
          product
            .querySelector(".strc-product-info__title")
            ?.textContent.trim() || "unknown_product";

        this.sendEvent({
          event_name: "click_comments_product",
          event_type: "click",
          page: pageType,
          element: `comments_product_${productTitle}`,
          action_value: "click",
        });
      }

      const commentsFlowBtn = e.target.closest(
        ".comments-card-flow-list__item-btn"
      );
      if (commentsFlowBtn) {
        this.sendEvent({
          event_name: "click_comments_flow_btn",
          event_type: "click",
          page: pageType,
          action_value: "click",
        });
      }

      // 吸顶下拉导航点击
      const stickySelectOption = e.target.closest(
        "custom-select .select-option"
      );
      if (stickySelectOption) {
        const productTitle =
          stickySelectOption.textContent.trim() || "unknown_sticky_select_nav";
        this.sendEvent({
          event_name: "click_sticky_select_nav",
          event_type: "click",
          page: pageType,
          element: `sticky_select_nav_${productTitle}`,
          action_value: "click",
        });
      }
    });

    const videoSliders = document.querySelectorAll(
      ".skin-transformation-comments .strc-content-swiper"
    );
    videoSliders.forEach((slider) => {
      let touchStartX;
      slider.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.touches[0].pageX;
        },
        { passive: true }
      );

      slider.addEventListener("touchend", (e) => {
        if (!touchStartX) return;
        const touchEndX = e.changedTouches[0].pageX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          const direction = diff > 0 ? "left" : "right";

          this.sendEvent({
            event_name: "swipe_compare_comments",
            event_type: "swipe",
            page: pageType,
            element: "compare_comments_slider",
            action_value: direction,
          });
        }
        touchStartX = null;
      });
    });

    const cardFlowListSections = document.querySelectorAll(
      ".section-comments-card-flow"
    );

    cardFlowListSections.forEach((videos) => {
      this.observeElementOnce({
        element: videos,
        callback: () => {
          const videosTitle =
            videos.querySelector(".title-wrapper .title")?.textContent.trim() ||
            "unknown_reviews_flow";

          this.sendEvent({
            event_name: "view_comment_flows",
            event_type: "view",
            page: pageType,
            element: `comment_flows_${videosTitle}`,
            action_value: "view",
          });
        },
        threshold: 0,
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.gaTracking = new GATracking();
});
